import React from "react";
import Withdraw from "Pages/Profile/withdraw-history";

const WithdrawTheme = () => {
  return (
    <React.Fragment>
      <Withdraw />
    </React.Fragment>
  );
};

export default WithdrawTheme;
